import React, { useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import AuthServices from "../../services/Auth.services";
import "../../assets/css/authentification/forgot-password.css";
import LoaderAuth from "../../components/loader/authentification/LoaderAuth";

const ResetPassword = ({ setAlert }) => {
  const navigate = useNavigate();
  const { userId, token } = useParams();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { isLoading, setIsLoading } = useContext(AuthContext);

  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);

  const handleSubmit = async (e) => {
    
    
    e.preventDefault();

    if (newPassword.length < 6) {
      setAlert({ message: "Mot de passe trop court (min 6).", type: "danger" });
      return;
    }
    if (newPassword !== confirm) {
      setAlert({ message: "Les mots de passe ne correspondent pas.", type: "danger" });
      return;
    }

    setIsLoading(true);

    try {
       
      if (executeRecaptcha) {
        const recToken = await executeRecaptcha("reset_password");
      }

      await AuthServices.resetPassword({ userId, token, newPassword });

      setAlert({ message: "Mot de passe mis à jour. Vous pouvez vous connecter.", type: "success" });
      setIsLoading(false);
      navigate("/connexion");
    } catch (err) {
      setIsLoading(false);
      setAlert({
        message: err?.response?.data?.message || "Lien invalide ou expiré.",
        type: "danger",
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <LoaderAuth />
      ) : (
        <div className="container pb-5 mb-5 pt-5 forgot_page">
          <i
            className="bi bi-x-circle login_icon_x"
            role="button"
            onClick={() => navigate("/connexion")}
          ></i>

          <div className="forgot_card">
            <div className="forgot_header">
              <h1>Nouveau mot de passe</h1>
              <p>Choisissez un nouveau mot de passe pour votre compte.</p>
            </div>

            <form className="forgot_form" onSubmit={handleSubmit}>
              <div className="w-100 position-relative">
                <input
                  type={show ? "text" : "password"}
                  placeholder="Nouveau mot de passe"
                  className="signin_input_text w-100"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <i
                  className="bi bi-eye position-absolute"
                  style={{ top: "15px", right: "25px", fontSize: "18px" }}
                  onClick={() => setShow(!show)}
                  role="button"
                ></i>
              </div>

              <input
                type={show ? "text" : "password"}
                placeholder="Confirmer le mot de passe"
                className="signin_input_text"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />

              <button type="submit" className="login_validate">
                ENREGISTRER
              </button>

              <div className="forgot_footer">
                <span role="button" className="forgot_back" onClick={() => navigate("/connexion")}>
                  ← Retour à la connexion
                </span>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPassword;
